export default "__VITE_ASSET__ad90a60d__"